function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { Text } from "react-native";
import { useBiblo } from "../hooks/Biblo.hook";
import { getTextStyles } from "../helpers/getStyles.helper";
export let TypographySize;
(function (TypographySize) {
  TypographySize["Small"] = "small";
  TypographySize["Medium"] = "medium";
  TypographySize["Large"] = "large";
})(TypographySize || (TypographySize = {}));
export const Typography = _ref => {
  let {
    size = TypographySize.Medium,
    bold,
    italic,
    color: colorProp,
    marginTop,
    marginBottom,
    opacity,
    children,
    style,
    disableDefaultStyles,
    ...props
  } = _ref;
  const {
    defaultStyles
  } = useBiblo();
  const color = colorProp || defaultStyles.textColor;
  const fontSize = defaultStyles.fontSizes[size];
  const lineHeight = defaultStyles.fontSizes[size] * defaultStyles.lineHeight;
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    style: getTextStyles(style, {
      color,
      fontSize,
      fontWeight: bold ? "bold" : undefined,
      fontStyle: italic ? "italic" : undefined,
      lineHeight,
      opacity,
      marginTop,
      marginBottom
    }, disableDefaultStyles)
  }), children);
};
//# sourceMappingURL=Typography.component.js.map